import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PageLoader from 'shared/components/PageLoader'
import { LOCAL_STORAGE_REDIRECT_URL_LOGOUT } from 'shared/constants/localStorageVariables'
import { redirectWithUri } from './shared/utils/redirectWithRedirectUrl'

const AfterLogout: React.FC = () => {
  const history = useHistory()

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE_REDIRECT_URL_LOGOUT)) {
      redirectWithUri()
      return
    }

    history.replace(`/`)
  })

  return <PageLoader />
}

export default AfterLogout
